import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=41c17bb4&scoped=true&"
import script from "./about-us.vue?vue&type=script&lang=js&"
export * from "./about-us.vue?vue&type=script&lang=js&"
import style0 from "./about-us.vue?vue&type=style&index=0&id=41c17bb4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c17bb4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IntSlides: require('/var/www/pb-store/components/IntSlides.vue').default,ContactForm: require('/var/www/pb-store/components/ContactForm.vue').default})
